// extracted by mini-css-extract-plugin
export default {"empty":"EmptySection_empty__GclQs"};